import cx from 'classnames';
import {
    ADMINCLUB_MENU,
    PROFILE_username_BLOCKED_BY_USER,
    PROFILE_BLOCKED__HEADER_username,
    PROFILE_BLOCKED__REASON1_kodex,
    PROFILE_BLOCKED__REASON2,
    PROFILE_BLOCKED__REASON3,
    PROFILE_BLOCKED__REASON4,
    PROFILE_BLOCKED__REASON5,
    PROFILE_BLOCKED__REASONS_ARE,
    RULES_KODEX__GENITIVE,
    USER_UNLIKE,
} from 'mk/autogenerated/translations/ProfileIsBlocked.4ac317664a77a9d31ad69ddcd084c3b7'
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { aboutRulesCodexUrl } from 'mk2/apps/about/urls';
import { adminclubUsers } from 'mk2/apps/adminclub/urls';
import { Btn,  BtnLayout, BtnSidePadding, BtnType } from 'mk2/components/Btn';
import { Interpolate } from 'mk2/components/Interpolate';
import { Link } from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './ProfileIsBlocked.mscss';

interface OwnProps {
    className?: string;
    username: string;
    isAdmin: boolean;
    isBlockedSelf: boolean;
    isLegacyBlocked: boolean;
    isLiked: boolean;
    onUnlike();
}

type Props = OwnProps;

const ProfileIsBlocked: React.FunctionComponent<Props> = ({
    className,
    username,
    isAdmin,
    isBlockedSelf,
    isLegacyBlocked,
    isLiked,
    onUnlike,
}) => {
    return (
        <div className={cx(styles.ProfileIsBlocked, className)}>
            {isBlockedSelf ? (
                <>
                    <h2>
                        <Interpolate
                            i18nKey={PROFILE_username_BLOCKED_BY_USER}
                            username={<strong>{username}</strong>}
                        />
                    </h2>
                    <p>
                        {isAdmin && (
                            <Btn
                                type={BtnType.AdminTextLight}
                                label={ADMINCLUB_MENU}
                                link={url(adminclubUsers, {}, { user: username })}
                                sidePadding={BtnSidePadding.None}
                            />
                        )}
                    </p>
                </>
            ) : (
                <>
                    <h2>
                        <Interpolate
                            i18nKey={PROFILE_BLOCKED__HEADER_username}
                            username={<strong>{username}</strong>}
                        />
                    </h2>
                    <p>{PROFILE_BLOCKED__REASONS_ARE}</p>
                    <ul>
                        <li>
                            <Interpolate
                                i18nKey={PROFILE_BLOCKED__REASON1_kodex}
                                kodex={<Link to={aboutRulesCodexUrl}>{RULES_KODEX__GENITIVE}</Link>}
                            />
                        </li>
                        {isLegacyBlocked ? (
                            <>
                                {PROFILE_BLOCKED__REASON2 && ACTIVE_SERVER_ID === 201 && (
                                    <li>{PROFILE_BLOCKED__REASON2}</li>
                                )}
                                {PROFILE_BLOCKED__REASON3 && <li>{PROFILE_BLOCKED__REASON3}</li>}
                                {PROFILE_BLOCKED__REASON4 && <li>{PROFILE_BLOCKED__REASON4}</li>}
                            </>
                        ) : (
                            <>
                                {PROFILE_BLOCKED__REASON5 && <li>{PROFILE_BLOCKED__REASON5}</li>}
                                {PROFILE_BLOCKED__REASON2 && <li>{PROFILE_BLOCKED__REASON2}</li>}
                                {PROFILE_BLOCKED__REASON3 && <li>{PROFILE_BLOCKED__REASON3}</li>}
                            </>
                        )}
                    </ul>
                    <p>
                        {isAdmin && (
                            <Btn
                                type={BtnType.AdminTextLight}
                                label={ADMINCLUB_MENU}
                                link={url(adminclubUsers, {}, { user: username })}
                                sidePadding={BtnSidePadding.None}
                            />
                        )}
                    </p>
                </>
            )}
            {isLiked && (
                <div>
                    <Btn
                        layout={BtnLayout.IconLabelCount}
                        type={BtnType.BlueOutline}
                        label={<b>{USER_UNLIKE}</b>}
                        onClick={onUnlike}
                    />
                </div>
            )}
        </div>
    );
};

ProfileIsBlocked.displayName = 'ProfileIsBlocked';

export default React.memo<Props>(ProfileIsBlocked);
